import { Injectable } from '@angular/core';

export interface CalculatorTab {
  label: string;
  route: string;
  description: string;
}

@Injectable({
  providedIn: 'root'
})
export class CalculatorTabsService {
  private tabs: CalculatorTab[] = [
    {
      label: 'Bad Man Forward',
      route: 'dcf',
      description: 'Perfect for companies on di rise and growing fast, think NVDA, PLTR, TSLA. This calculator finds the fair price of a stock based on its earnings growth, built for businesses pushing forward and expanding fast.'
    },
    {
      label: 'Graham Remix',
      route: 'graham-price',
      description: 'Great for true value investors looking for a quality inexpensive company (we don\'t do cheap). Calculate the sticker price using a modified version of Ben Graham\'s formula. Formula: √(Median PE × 1.5 × EPS × BVPS)'
    },
    
    {
      label: 'Money A Run',
      route: 'money-a-run',
      description: 'Free cash flow haffi run like river, great for cashflowing business with little debt. This tool shows how long it takes to earn back your investment from steady cash flows — perfect for cash-rich, consistent companies.'
    },
    {
      label: 'Big Up Yield',
      route: 'big-up-yield',
      description: 'Big up di earnings, for companies that just bring steady returns, i.e. KO (Coca-Cola). This calculator finds the fair price of a stock based on how much profit it generates for every dollar invested, highlighting true value plays.'
    },
    {
      label: 'Growth Rate',
      route: 'growth-rate',
      description: 'Calculate Compound Annual Growth Rate (CAGR) for revenue, earnings, or other financial metrics to assess company performance.'
    }
  ];

  getTabs(): CalculatorTab[] {
    return this.tabs;
  }

  getTabByRoute(route: string): CalculatorTab | undefined {
    return this.tabs.find(tab => tab.route === route);
  }
}
